import { StateCreator } from 'zustand'
import { getNotifications as getNotificationEndpoint } from '../api/endpoints'
import { deleteNotification as deleteNotificationEndpoint } from '../api/endpoints'
import { clearNotifications as clearNotificationsEndpoint } from '../api/endpoints'
import axiosInstant from '../api'

interface Notification {
  id: number
  content: string
  createdAt: string | Date
  payload: string
  title: string
}

export interface NotificationSlice {
  notifications: Notification[] | null
  getNotifications: () => Promise<void>
  deleteNotification: (id: number) => Promise<void>
  clearAllNotifications: () => Promise<void>
  updateNotificationStatus: () => void
}

export const createNotificationSlice: StateCreator<NotificationSlice, [], [], NotificationSlice> = (set, get) => {
  const notifications = null

  const getNotifications = async () => {
    try {
      const response = await axiosInstant.get(getNotificationEndpoint())
      const { data, status } = response
      if (status === 200) {
        const { data: actualData } = data
        const normalized = actualData.map((item: Notification) => ({
          ...item,
          content: item.content.length > 300 ? item.content.substring(0, 300) + '...' : item.content,
          createdAt: new Date(item.createdAt),
        }))
        set((state) => ({
          ...state,
          notifications: normalized,
        }))
      }
    } catch (error) {
      console.error(error)
    }
  }

  const deleteNotification = async (id: number) => {
    try {
      const response = await axiosInstant.delete(deleteNotificationEndpoint(id))
      const { status } = response
      if (status === 200) {
        set((state) => ({
          ...state,
          notifications: state.notifications?.filter((notification) => notification.id !== id),
        }))
      }
    } catch (error) {
      console.error(error)
    }
  }

  const updateNotificationStatus = async () => {
    try {
      const response = await axiosInstant.patch('/notifications/status', { status: true })
      const { status } = response
      if (status === 200) {
        getNotifications();
      }
    } catch (error) {
      console.error(error)
    }
  }

  const clearAllNotifications = async () => {
    try {
      const response = await axiosInstant.delete(clearNotificationsEndpoint())
      const { status } = response
      if (status === 200) {
        set((state) => ({
          ...state,
          notifications: [],
        }))
      }
    } catch (error) {
      console.error(error)
    }
  }

  return { notifications, getNotifications, deleteNotification, clearAllNotifications, updateNotificationStatus }
}
